.mobileFiltersModal {
  margin-left: 10%;
  width: 90%;
  position: relative;
  transform: none;
  top: 0;
  left: 0;
}

.mobileFiltersButton {
  width: 48px;
  position: relative;
  white-space: nowrap;
}

.filterCount {
  position: absolute;
  top: -2px;
  right: -2px;
  color: var(--colors-text-inverse);
  background-color: var(--colors-primary-main);
  height: 20px;
  min-width: 20px;
  text-align: center;
  border-radius: 10px;
  line-height: 20px;
  font-size: 12px;
  pointer-events: none;
}

@media all and (--reefer-media-tablet-min) {
  .mobileFiltersButton {
    display: none;
  }
}
